export enum ENativeSettingsContext {
    /** not about the current app, but location for all apps */
    location = "location",
    /** only about the current app, but all settings */
    app = "application_details"
}